import React from "react";
import { routeNames } from "../../../routes/routeNames";
import { FaExternalLinkAlt } from "react-icons/fa";
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { useNavigate } from "react-router-dom";


const defaultStyles = {
  mainStyle:
    "mt-8 flex flex-col justify-center sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-4",
  bookOnlineButton:
    "bg-primary text-white py-4 px-8 rounded-full font-semibold text-center",
  callButton:
    "bg-orange text-white py-4 px-8 rounded-full font-semibold text-center",
};

const ContactButton = ({
  mainContStyle = defaultStyles.mainStyle,
  bookOnlinestyle = defaultStyles.bookOnlineButton,
  bookOnlineText = "Book Online",
  callButtonStyle = defaultStyles.callButton,
}) => {
  const navigate = useNavigate()
  return (
    <div>
      <div className={` ${mainContStyle}`}>
        <a onClick={()=>navigate(routeNames.contact)} className={` ${bookOnlinestyle}`}>
          <div className="flex items-center">
            <h3>{bookOnlineText}</h3> <FaExternalLinkAlt className="ml-2" />
          </div>
        </a>
        <a href={"tel:+1 (226) 368-1309"} className={` ${callButtonStyle}`}>
        <div  className="flex items-center justify-center"><MdOutlinePhoneInTalk size={22} className="mr-3"/> +1 (226) 368-1309</div>
        </a>
      </div>
    </div>
  );
};

export default ContactButton;
